import { oz } from '@weft/utils';
import { ConditionInputSchema } from './condition-input-schema';

export const FilterInputSchema = oz.object({
  conditions: oz.array(ConditionInputSchema),
});

export type FilterInput = oz.infer<typeof FilterInputSchema>;